export const applyGradient = () => {
  return `
  background: linear-gradient(120deg, #ecf2fb, #8597b0, #4d2dd4);
  background-size: 250% 150%;
  `;
};
